import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.7618 8.5L12 1.91406L9.23816 8.5H14.7618Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.6006 10.5H8.39945L6.83493 14.2308H17.1651L15.6006 10.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.0038 16.2308H5.99622L4.83498 18.9999H3V20.9999H21V18.9999H19.165L18.0038 16.2308Z"}}]};

const TrafficEventsFilled = Vue.extend<IconProps>({
  name: 'TrafficEventsFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'traffic-events-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default TrafficEventsFilled;
